var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarningTriangleSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.16 4.625c-.959-1.656-3.36-1.655-4.318 0L2.635 17.067c-.962 1.66.25 3.716 2.159 3.716h14.411c1.909 0 3.12-2.056 2.16-3.716zM12.7 9.083a.7.7 0 1 0-1.4 0v4a.7.7 0 1 0 1.4 0zm-.693 6.434a.9.9 0 0 1 .9.9v.007a.9.9 0 1 1-1.8 0v-.008a.9.9 0 0 1 .9-.9",
  clipRule: "evenodd"
})));
export default SvgWarningTriangleSolid;